import { createBrowserHistory } from 'history';

import { config } from 'app/config/config';
import { ParamUtils } from 'app/utils/param-utils';

const BASE_PATH: string = '/';

const history = createBrowserHistory({ basename: BASE_PATH });

class NavigationService {
    public static readonly CHOOSE_ACCOUNT: string = '/choose-account';
    public static readonly CHOOSE_SERVICE_LOCATION: string = '/choose-service-location';
    public static readonly SUMMARY: string = '/summary';
    public static readonly NO_INFLIGHT_ORDERS: string = '/no-inflight-orders';
    public static readonly NO_BILLING_ACCOUNTS: string = '/no-billing-accounts';
    public static readonly AUTH_CALLBACK: string = '/auth/callback/';
    public static readonly LOGOUT: string = '/auth/logout';
    public static readonly RESCHEDULE_TECHNICIAN: string = '/reschedule-technician';
    public static readonly UPDATE_ACTIVATION_DATE: string = '/update-activation-date';

    public readonly goToPath = (path: string): void => history.push(path);

    public readonly goToHomePage = (): void => {
        window.location.href = config.HOME_PAGE_URL;
    };

    public readonly goToMyPages = (): void => {
        window.location.href = config.MY_PAGES_URL;
    };

    public readonly getAccountIdFromQueryString = (): string | null => ParamUtils.getQueryParam('accountId');
}

const navigationService = new NavigationService();

export { history, navigationService, NavigationService };
